import { Box, Card } from 'rebass'
import { Marker as GoogleMapsMarker, InfoWindow } from 'react-google-maps'
import { compose, withStateHandlers } from 'recompose'

import React from 'react'
import { Trans } from '@lingui/macro'

const Marker = ({
  icon,
  isOpen,
  navigateLink,
  onToggleOpen,
  position,
  title,
}) => {
  return (
    <GoogleMapsMarker onClick={onToggleOpen} position={position}>
      {isOpen && (
        <InfoWindow onCloseClick={onToggleOpen}>
          <Card>
            {icon} <strong>{title}</strong>
            <Box>
              <a href={navigateLink} target="_blank" rel="noopener noreferrer">
                <Trans>Navigovat</Trans>
              </a>
            </Box>
          </Card>
        </InfoWindow>
      )}
    </GoogleMapsMarker>
  )
}

export default compose(
  withStateHandlers(
    () => ({
      isOpen: true,
    }),
    {
      onToggleOpen: ({ isOpen }) => () => ({
        isOpen: !isOpen,
      }),
    }
  )
)(Marker)
